export default __webpack_public_path__ + "static/media/rightMoon.5020f60a.gif";